import { CSSProperties, FC, useMemo } from 'react';

import { Box, BoxProps, useTheme } from '@mui/material';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type RatingStarIconProps = {
  isEmpty?: boolean;
  rootSx?: BoxProps['sx'];
  iconStyle?: CSSProperties;
};

const RatingStarIcon: FC<RatingStarIconProps> = ({ isEmpty, rootSx = {}, iconStyle = {} }) => {
  const theme = useTheme();

  const iconName = useMemo(() => {
    if (isEmpty) {
      return 'fa-light fa-star';
    }
    return 'fa-solid fa-star';
  }, [isEmpty]);

  const iconColor = useMemo(() => {
    if (isEmpty) {
      return '';
    }
    return theme.palette.warning.main;
  }, [isEmpty, theme]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 18, height: 18, ...rootSx }}>
      <FontAwesomeIcon icon={iconName} style={{ color: iconColor, fontSize: 12, ...iconStyle }} />
    </Box>
  );
};

export default RatingStarIcon;
